import "./CheckBox.css";
import * as React from "react";

export interface CheckboxProps {
    label: string;
    checked: boolean;
    onClick?: (checked: boolean) => void;
    disabled?: boolean;
}

export const CustomCheckbox = (props: CheckboxProps) => {
    const checkmarkClass = props.checked && !props.disabled ? "checkmark checked" : "checkmark";
    const disabledClass = props.disabled ? " disabled" : "";
    return (
        <div className="checkbox-container" onClick={() => !props.disabled && props.onClick && props.onClick(!props.checked)}>
            <div className={checkmarkClass + disabledClass}>
                {props.checked && <span>&#10003;</span>}
            </div>
            <label className={"checkbox-label" + disabledClass}>{props.label}</label>
        </div>
    );
};

export const DefaultCheckbox = (props: CheckboxProps) => {
    return (
        <div className="checkbox-container default" onClick={() => !props.disabled && props.onClick && props.onClick(!props.checked)}>
            <input type="checkbox" disabled={props.disabled} checked={props.checked} />
            <label>{props.label}</label>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/customFormComponents/CheckBoxGroup/Checkbox.tsx